import { io } from "socket.io-client";
import { serverURL } from "./Fetchnodeservices";

console.log("🌐 Socket URL:", serverURL);

const socket = io(serverURL, {
  transports: ["websocket"],
  autoConnect: false,
});

socket.on("connect", () => {
  console.log("🟢 SOCKET CONNECTED:", socket.id);
});

socket.on("disconnect", () => {
  console.log("🔴 SOCKET DISCONNECTED");
});

socket.on("connect_error", (err) => {
  console.log("❌ SOCKET ERROR:", err.message);
});

export default socket;